import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';

const initialState = {
  error: null,
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PASSWORD_REQUEST:
      return { ...state, error: null, isFetching: true };
    case types.SET_PASSWORD_SUCCESS:
      return { ...state, isFetching: false };
    case types.SET_PASSWORD_ERROR:
      return {
        ...state,
        error: getErrorMessage(action.payload),
        isFetching: false,
      };
    default:
      return state;
  }
};

export default reducer;
